module.exports = __webpack_public_path__ + "img/reverse1.45103241.png";